import { render, staticRenderFns } from "./TableCellStars.vue?vue&type=template&id=40f37008&scoped=true&"
import script from "./TableCellStars.vue?vue&type=script&lang=js&"
export * from "./TableCellStars.vue?vue&type=script&lang=js&"
import style0 from "./TableCellStars.vue?vue&type=style&index=0&id=40f37008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f37008",
  null
  
)

export default component.exports